export const routes = {
  audit: {
    index: '/audits',
    details: '/audits/:auditId',
    settings: '/audits/:auditId/settings',
    create: '/audits/create',
    eaBackgroundForm: '/audits/:auditId/energy-audit/forms/background',
    eaMechanicalForm: '/audits/:auditId/energy-audit/forms/mechanical',
    eaMechanicalFormEntry:
      '/audits/:auditId/energy-audit/forms/mechanical/:index',
    eaLightingTypeForm: '/audits/:auditId/energy-audit/forms/lighting-type',
    eaLightingTypeFormEntry:
      '/audits/:auditId/energy-audit/forms/lighting-type/:index',
    eaLightingCountForm: '/audits/:auditId/energy-audit/forms/lighting-count',
    eaLightingCountFormEntry:
      '/audits/:auditId/energy-audit/forms/lighting-count/:index',
    eaWaterFixtureForm: '/audits/:auditId/energy-audit/forms/water-fixture',
    eaWaterFixtureFormEntry:
      '/audits/:auditId/energy-audit/forms/water-fixture/:index',
    eaWindowsForm: '/audits/:auditId/energy-audit/forms/windows',
    eaWindowsFormEntry: '/audits/:auditId/energy-audit/forms/windows/:index',
    eaChecklistForm: '/audits/:auditId/energy-audit/forms/checklist',
    eaEcmsForm: '/audits/:auditId/energy-audit/forms/ecms',
    eaReviewSubmit: '/audits/:auditId/energy-audit/review-submit',

    getDetailsPath: (auditId: string) => `${routes.audit.index}/${auditId}`,

    getSettingsPath: (auditId: string) =>
      `${routes.audit.index}/${auditId}/settings`,

    getEnergyAuditFormPath: (auditId: string, formId: string) =>
      `${routes.audit.index}/${auditId}/energy-audit/forms/${formId}`,

    getEnergyAuditReviewSubmitPath: (auditId: string) =>
      `${routes.audit.index}/${auditId}/energy-audit/review-submit`,

    getEnergyAuditBackgroundFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'background'),

    getEnergyAuditMechanicalFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'mechanical'),

    getEnergyAuditMechanicalFormEntryPath: (
      auditId: string,
      entryIndex: number,
    ) =>
      `${routes.audit.getEnergyAuditMechanicalFormPath(auditId)}/${entryIndex}`,

    getEnergyAuditLightingTypeFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'lighting-type'),

    getEnergyAuditLightingTypeFormEntryPath: (
      auditId: string,
      entryIndex: number,
    ) =>
      `${routes.audit.getEnergyAuditLightingTypeFormPath(auditId)}/${entryIndex}`,

    getEnergyAuditLightingCountFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'lighting-count'),

    getEnergyAuditLightingCountFormEntryPath: (
      auditId: string,
      entryIndex: number,
    ) =>
      `${routes.audit.getEnergyAuditLightingCountFormPath(auditId)}/${entryIndex}`,

    getEnergyAuditWaterFixtureFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'water-fixture'),

    getEnergyAuditWaterFixtureFormEntryPath: (
      auditId: string,
      entryIndex: number,
    ) =>
      `${routes.audit.getEnergyAuditWaterFixtureFormPath(auditId)}/${entryIndex}`,

    getEnergyAuditWindowsFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'windows'),

    getEnergyAuditWindowsFormEntryPath: (auditId: string, entryIndex: number) =>
      `${routes.audit.getEnergyAuditWindowsFormPath(auditId)}/${entryIndex}`,

    getEnergyAuditChecklistFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'checklist'),

    getEnergyAuditEcmsFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'ecms'),
  },

  userProfile: {
    index: '/user-profile',
  },

  appSettings: {
    index: '/app-settings',
  },
};
